import { Stack } from '@mantine/core';
import { Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { NoContentPlaceholder } from '@/core/components';

import { HierarchyFacultySelect } from '@feature/utils';
import { useFacultyAdminHierarchy } from '@feature/utils/components/hooks/hierarchy/useHierarchy';

export function FacultyAdminGovEvaluationHeader() {
  const { userId, selectProps } = useFacultyAdminHierarchy();
  const { t } = useTranslation();

  return (
    <Stack>
      <HierarchyFacultySelect {...selectProps} />
      {userId == null && <NoContentPlaceholder title={t('hierarchySelectValidation.fromFaculties')} />}
      {userId != null && <Outlet />}
    </Stack>
  );
}
